<template>
  <div>
    <div class="burger img-w" @click="toggleMenu">
      <img src="@/assets/img/redesign_may_2026/burger.svg" alt="Меню" />
    </div>

    <div class="menu-backdrop" :class="{'is-visible': menu}" @click="toggleMenu" />

    <div class="menu" :class="{'is-visible': menu}">
      <div class="menu__close img-w" @click="toggleMenu">
        <svg viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1.41406" y="0.893555" width="28" height="2" transform="rotate(45 1.41406 0.893555)" fill="#0078c8"/>
          <rect width="28" height="2" transform="matrix(-0.707107 0.707107 0.707107 0.707107 19.7988 0.893555)" fill="#0078c8"/>
        </svg>
      </div>
      <div class="menu__logo img-w">
        <img src="@/assets/img/logo.png" alt="">
      </div>
      <ul class="menu__list">
        <li><a href="#" v-scroll-to="'#main'" @click="toggleMenu">Главная</a></li>
        <li><a href="#" v-scroll-to="'#products'" @click="toggleMenu">Продукты</a></li>
        <li>
          <a href="https://xn--80aaahigmnflbhtmmnk4a5ag7v.xn--p1ai/?utm_source=pulpysite&utm_medium=main" @click="toggleMenu">Разделяй упаковку</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MobileMenu",
    data() {
      return {
        menu: false,
      }
    },

    methods: {
      toggleMenu() {
        this.menu = !this.menu;
        if (typeof document !== 'undefined') {
          document.body.style.overflow = this.menu ? 'hidden' : '';
        }
      },
    },
    beforeDestroy() {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "burger";
  @import "menu";
</style>
